import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';

interface OrderRowProps {
  order: any;
}

const OrderRow: React.FC<OrderRowProps> = ({ order }) => {
  return (
    <TableRow>
      <TableCell>{order.id}</TableCell>
      <TableCell>{new Date(order.createdAt).toLocaleDateString()}</TableCell>
      <TableCell>{order.totalPrice}</TableCell>
      <TableCell>
        {order.lineItems.map((item: any) => (
          <div key={item.title}>
            {item.title}
          </div>
        ))}
      </TableCell>
      <TableCell>
        {order.lineItems.map((item: any) => (
          <div key={item.title}>
            {item.quantity}
          </div>
        ))}
      </TableCell>
      <TableCell>
        <Chip label={order.fulfillmentStatus || 'Pending'}/>
      </TableCell>
    </TableRow>
  );
};

export default OrderRow;
